import { render, staticRenderFns } from "./dropzoneCompV2.vue?vue&type=template&id=7333704c&scoped=true"
import script from "./dropzoneCompV2.vue?vue&type=script&lang=js"
export * from "./dropzoneCompV2.vue?vue&type=script&lang=js"
import style0 from "./dropzoneCompV2.vue?vue&type=style&index=0&id=7333704c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7333704c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VChip,VCol,VIcon,VRow})
